module.exports = __webpack_public_path__ + "img/play.4885afb1.png";